import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useFormContext, FormProvider } from 'react-hook-form';
import { useMutationState } from '@tanstack/react-query';
import PartnerCustomTagField from '../PartnerCustomTagField';

const AdminCardEdit = ({ admin, onResetPassword, onArchive, onUpdate, onCancel, auth }) => {
  const { t } = useTranslation();
  const state = useMutationState({
    filters: { mutationkey: ['administration', 'admin-users', 'save'] },
    select: (mutation) => mutation.state,
  })

  const latest = state[state.length - 1]
  const isPending = latest && latest.status === 'pending'

  const formMethods = useFormContext();
  const {
    reset,
    register,
    handleSubmit,
    clearErrors,
    formState: { errors },
  } = formMethods;
  return (
    <div className='o-card__wrap o-admin-card'>
      <section className='column o-card cs-bg--light'>
        <div className='row'>
          <div className='column small-12 medium-6'>
            <h3><b>{admin.name}</b></h3>
            {admin.is_administrator && (<p>
              <i>{t('administration.staff.columns.adminLevelAccess')}</i>
            </p>)}
            <p>
                {t('administration.staff.status.label')}{admin.archived ? t('administration.staff.status.archived') : t('administration.staff.status.active')}
            </p>
          </div>
          <div className='column small-12 medium-6' style={{textAlign:'right'}}>
            <span className='o-sp-button o-sp-button--update action-btn' onClick={() => {
              onResetPassword(admin.id);
            }}>
              <i className='fa fa-envelope'></i>&nbsp;{t('administration.staff.resetPassword')}
            </span>
            <span className='o-sp-button o-sp-button--update action-btn u-margin-top--small' onClick={() => {
              onArchive(admin.id);
            }}>
              <i className='fa fa-archive'></i>&nbsp;{admin.archived ? t('administration.staff.unarchive') : t('administration.staff.archive')}
            </span>
          </div>
        </div>
        <FormProvider {...formMethods}>
          <form onSubmit={(e) => {
            clearErrors();
            handleSubmit(onUpdate)(e);
          }}>
            <div className='u-margin-top--base'>
              <p>
                <span className='u-txt--label'>{t('administration.staff.name')}</span><br />
                <input type='text' {...register('name')} aria-invalid={errors.name ? 'true' : 'false'} />
                {errors.name && <p className='u-txt--error'>{errors.name.message}</p>}
              </p>
              <p>
                <span className='u-txt--label'>{t('administration.staff.email')}</span><br />
                <input type='email' {...register('email')} aria-invalid={errors.email ? 'true' : 'false'} />
                {errors.email && <p className='u-txt--error'>{errors.email.message}</p>}
              </p>
              <div>
                <PartnerCustomTagField kind='admin_user_type' label={t('administration.staff.adminUserType')} />
              </div>
              { auth.isPartnerUsingSaml && (
                <p>
                  <label>
                    <input type='checkbox' {...formMethods.register('using_saml')} />
                    <span className='u-txt--label u-margin-left--small'>{t('administration.staff.ssoLabel')}</span>
                  </label>
                </p>
              )}
            </div>
            <div className='row'>
              <div className='column small-12 medium-3'>
                <input type='submit' className='o-sp-button o-sp-button--update o-sp-button--primary' value={t('actions.save')} disabled={isPending} />
              </div>
              <div style={{textAlign: 'right'}} className='column small-12 medium-3'>
                <a className='o-sp-button o-sp-button--update o-sp-button--danger' onClick={() => {
                  reset()
                  onCancel()
                }}>
                  {t('actions.cancel')}
                </a>
              </div>
            </div>
          </form>
        </FormProvider>
      </section>
    </div>
  );
};

AdminCardEdit.propTypes = {
  auth: PropTypes.object.isRequired,
  admin: PropTypes.object.isRequired,
  onResetPassword: PropTypes.func.isRequired,
  onArchive: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default AdminCardEdit;
